import { session } from '$lib/stores/session.svelte';

const initial = {
	from: '',
	fromPlaceId: '',
	to: '',
	toPlaceId: '',
	date: '',
	time: '',
	adults: 0,
	children: 0,
	infants: 0
};

export const searchFrom = session('searchFrom', initial.from);
export const searchFromPlaceId = session('searchFromPlaceId', initial.fromPlaceId);
export const searchTo = session('searchTo', initial.to);
export const searchToPlaceId = session('searchToPlaceId', initial.toPlaceId);
export const searchDate = session('searchDate', initial.date);
export const searchTime = session('searchTime', initial.time);
export const searchAdults = session('searchAdults', initial.adults);
export const searchChildren = session('searchChildren', initial.children);
export const searchInfants = session('searchInfants', initial.infants);

export const clearSearchStore = () => {
	searchFrom.current = initial.from;
	searchTo.current = initial.to;
	searchDate.current = initial.date;
	searchTime.current = initial.time;
	searchAdults.current = initial.adults;
	searchChildren.current = initial.children;
	searchInfants.current = initial.infants;
	searchFromPlaceId.current = initial.fromPlaceId;
	searchToPlaceId.current = initial.toPlaceId;
};
